import React, { useEffect, useState } from 'react';
import { useI18n } from 'hooks/use_i18n';
import { SoftBadge } from 'components/ui';
import { sortBy, cloneDeep } from 'lodash';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './filter_list.scss';

const filterList = ({ list, filters, initialActiveFilters, setFiltered, bottomList, callbackActiveFilters, labels }) => {
  const { t } = useI18n();

  const [activeFilters, setActiveFilters] = useState([...initialActiveFilters]);

  const addFilter = (filter) => {
    const index = activeFilters.indexOf(filter);

    if (index === -1) setActiveFilters([...activeFilters, filter]);
    else {
      let newActiveFilters = cloneDeep(activeFilters);
      newActiveFilters.splice(index, 1);
      setActiveFilters([...newActiveFilters]);
    }
  };

  const formatString = (string) => (labels && labels[string]) || string.charAt(0).toUpperCase() + string.replace(/_/g, ' ').slice(1);

  useEffect(() => {
    if (callbackActiveFilters) {
      const result = filters.reduce((acc, val) => {
        acc[val] = false;
        return acc;
      }, {});
      activeFilters.forEach((val) => {
        if (val in result) {
          result[val] = true;
        } else {
          result[val] = false;
        }
      });
      callbackActiveFilters(result);
    }

    if (!setFiltered) {
      return;
    }

    if (!activeFilters.length) {
      setFiltered(sortBy(list, [(o) => bottomList.map((el) => o.status === el)]));
    } else {
      let filtered = [];
      activeFilters.map((filter) =>
        list.map((el) => {
          if (el.status === filter) filtered.push(el);
        }),
      );
      let filteredOrdered = sortBy(filtered, [(o) => bottomList.map((el) => o.status === el)]);
      setFiltered(filteredOrdered);
    }
  }, [activeFilters]);

  return (
    <div className="p-3 filter-list-container">
      <span>{t('components.ui.filter_list.filter_by_status')}:</span>
      {filters.map((el, i) => (
        <SoftBadge
          onClick={() => addFilter(el)}
          bg={activeFilters.includes(el) ? 'primary' : 'light'}
          className={classNames('cursor-pointer py-1 px-2 soft-border', {
            'mr-2': i !== filters.length - 1,
            'ml-2': i === 0,
          })}
          key={i}
        >
          {formatString(el)}
        </SoftBadge>
      ))}
    </div>
  );
};

filterList.defaultProps = {
  initialActiveFilters: [],
  setFiltered: false,
  bottomList: [],
  callbackActiveFilters: () => false,
};

filterList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object),
  filters: PropTypes.arrayOf(PropTypes.string),
  initialActiveFilters: PropTypes.array,
  setFiltered: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  bottomList: PropTypes.array,
  callbackActiveFilters: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  labels: PropTypes.object,
};

export default filterList;
